<template>
    <header class="aui-header-default aui-header-fixed t-bg">
        <div class="aui-header-center aui-header-center-clear">
            <div class="aui-header-center-logo">
                <div>
                    <img src="/images/pdx.png" alt="">
                </div>
            </div>
        </div>

    </header>
    <div class="clear"></div>

    <section class="n-tabs" style="text-align: center;">
        <ul class="n-tabContainer" id="auto-id-1509603311057">
            <li class="n-tabItem" id="home">
                <a class="current">秒杀活动区</a>
            </li>
        </ul>
    </section>
    <div class="clear"></div>
    <div class="hbox1"></div>
    <!-- <div class="tolist" @click="changeList()">
        <img src="../../static/images//tolist.png">
    </div> -->
    <div class="totop">
        <a href="javascript:scrollTo(0,0)">
            <img src="../../static/images//totop.png"></a>
    </div>
    <div class="kbox"></div>
    <div class="likebox" v-show="isShowLikeBox">
        <ul>


            <li v-for="(item, index) in seckillProductList">
                <a v-bind:href="`/seckillDetail/${item.id}`">
                    <img :src="item.productImg" :alt="item.productName" class="proimg" />
                    <p class="tit">{{ item.productName }}</p>
                    <p style="text-align: right;">
                        <span v-if="!isInitialized"></span>
                        <template v-else>
                            <span v-if="isSeckillOngoing(item)">秒杀倒计时: </span>
                            <span v-else>秒杀未开始: </span>
                            <span :style="{color:isSeckillOngoing(item) ? 'red' :'black'}">{{ getCountdown(item.seckillStartTime, item.seckillEndTime) }}</span>
                        </template>
                    </p>
                    <p class="price">￥{{ item.groupPrice }}<span>￥{{ item.marketPrice }}</span></p>
                    <p class="price"
                        style="background-color: #F79764; text-align: center; vertical-align: middle; line-height: 11px; color: red">
                        返税:￥{{ item.taxReturned }}</p>
                </a>
            </li>

        </ul>
    </div>
    <div class="shoplist" style="display: none" v-show="!isShowLikeBox">
        <ul>


            <li v-for="(item, index) in seckillProductList">
                <a v-bind:href="`/taxRefund/detail/${item.id}`">
                    <div class="listL">
                        <img :src="item.productImg" :alt="item.productName" class="proimg" />
                    </div>
                    <div class="listR">
                        <div class="v1">{{ item.productName }}</div>
                        <div class="v2"><span>返税:{{ item.taxReturned }}</span></div>
                        <div class="v3">
                            <p class="p1">￥{{ item.groupPrice }}<span>￥{{ item.marketPrice }}</span></p>
                            <p class="p2">{{ item.salesVol }}人付款</p>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <br><br><br>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { getSeckillProductList } from '@/api/seckill.js'
import { useRoute } from 'vue-router'
const seckillProductList = ref([])
const isShowLikeBox = ref(true)

const currentTime = ref(null);     // 当前时间
const isInitialized = ref(false); // 初始化状态
const isSeckillOngoing = (item) => {
    // 判断是否处于秒杀中
    return currentTime.value >= item.seckillStartTime && currentTime.value <= item.seckillEndTime;
};

const updateCountdown = (seckillStartTime, seckillEndTime) => {
    const targetTime = isSeckillOngoing(seckillStartTime, seckillEndTime) ? seckillEndTime : seckillStartTime;
    const targetDate = parseTime(targetTime);
    const now = new Date();
    // const endTimeTomorrow = parseTime(seckillStartTime) + 1;
    let diffInSeconds = Math.floor((targetDate - now) / 1000);

    if (diffInSeconds <= 0) {
        // 如果当前时间大于结束时间，设置目标时间为明天的开始时间
        const tomorrow = new Date(parseTime(seckillStartTime)); // 复制目标日期对象，以免直接修改原日期
        tomorrow.setDate(tomorrow.getDate() + 1); // 将日期增加1天
        targetDate.value = new Date(tomorrow)
        // const startTime = `${formatTime(targetDate.getHours())}:${formatTime(targetDate.getMinutes())}:${formatTime(targetDate.getSeconds())}`;
        diffInSeconds = Math.floor((targetDate.value - now) / 1000);
    }

    if (diffInSeconds <= 0) {
        return "00:00:00";
    }

    const hours = Math.floor(diffInSeconds / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    return `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
};




const formatTime = (time) => {
    // 格式化时间为两位数
    return time < 10 ? `0${time}` : time;
};


const changeList = () => {
    isShowLikeBox.value = !isShowLikeBox.value
}


const parseTime = (timeString) => {
    const parts = timeString.split(":");
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const seconds = parseInt(parts[2]);
    const targetTime = new Date();

    targetTime.setHours(hours);
    targetTime.setMinutes(minutes);
    targetTime.setSeconds(seconds);

    return targetTime;
};
const getCountdown = (item) => {
    return updateCountdown(item);
};



onMounted(() => {
    getSeckillProductList().then(res => {
        if (res && res.rows) {
            seckillProductList.value = res.rows
        }
    })
    // 模拟异步计算，延迟1秒设置isInitialized为true
    setTimeout(() => {
        isInitialized.value = true;
    }, 1000);

    // 每秒更新一次倒计时
    setInterval(() => {
        const now = new Date();
        currentTime.value = `${formatTime(now.getHours())}:${formatTime(now.getMinutes())}:${formatTime(now.getSeconds())}`;
    }, 1000);

})



</script>

<style>
.likebox ul li p.price {
    color: #ff2150;
    padding-top: 0.5rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.875rem;
}
</style>